import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appDniCif]'
})
export class DniCifDirective {

  @Output() validatorDniCif = new EventEmitter<boolean>();
  private regexDni: RegExp = new RegExp(/^(\d{8})([A-Z])$/);
  private regexCif: RegExp = new RegExp(/^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/);
  private regexNie: RegExp = new RegExp(/^[XYZ]\d{7,8}[A-Z]$/);

  constructor(private el: ElementRef) { }

  @HostListener('keyup', ['$event'])
  filterInput(event) {
    const current: string = this.el.nativeElement.value;
    if (this.regexDni.test(current) || this.regexCif.test(current) || this.regexNie.test(current)) {
      this.validatorDniCif.emit(true);
      return true;
    } else if (current === '') {
      this.validatorDniCif.emit(true);
      return true;
    } else {
      this.validatorDniCif.emit(false);
      event.preventDefault();
      return false;
    }
  }
}
